import { api } from './api';

export interface Tag {
  id: string;
  name: string;
  type: string;
  documentCount: number;
}

export interface CreateTagRequest {
  name: string;
  description?: string;
  type: string;
  icon?: string;
}

export interface UpdateTagRequest {
  id: string;
  name: string;
  description?: string;
  type: string;
  icon?: string;
}

class TagService {
  async getAllTags(): Promise<Tag[]> {
    const response = await api.get('/tags');
    return response.data;
  }

  async getTagById(id: string): Promise<Tag> {
    const response = await api.get(`/tags/${id}`);
    return response.data;
  }

  async getTagByType(type: string): Promise<Tag> {
    const response = await api.get(`/tags/type/${type}`);
    return response.data;
  }

  async createTag(tag: CreateTagRequest): Promise<Tag> {
    const response = await api.post('/tags', tag);
    return response.data;
  }

  async updateTag(id: string, tag: UpdateTagRequest): Promise<Tag> {
    const response = await api.put(`/tags/${id}`, tag);
    return response.data;
  }

  async deleteTag(id: string): Promise<void> {
    await api.delete(`/tags/${id}`);
  }

  async updateManyTags(tags: Tag[]): Promise<Tag[]> {
    const response = await api.put('/tags/batch', tags);
    return response.data;
  }

  async deleteManyTags(ids: string[]): Promise<void> {
    await api.delete('/tags/batch', { data: ids });
  }
}

export const tagService = new TagService(); 